import React from 'react'
import TermListEntry from './TermListEntry';
import TermList from './TermList';
import FriendList from './FriendList';
import resetBreadcrumbsTo from './App';
import {Breadcrumb,mandOServiceElement } from './myFunctions';
export default function ServiceMandO({oym,dropBreadcrumb,authenticated}) {
    let mandOObject =oym.objectRef(oym.data.ministryAndOversight);
    let ministryObject = oym.objectRef(mandOObject.ministers);
    let elderObject = oym.objectRef(mandOObject.elders);
    let overseerObject = oym.objectRef(mandOObject.overseers);
    // console.log("oym.data.ministryAndOversight",oym.data.ministryAndOversight);
    const whiteSpaceStyle = {
        'white-space': 'pre-line',
      };
    oym.buildMinistryAndOversightMembership(oym);
    // console.log("oym.data.ministryAndOversight2",oym.data.ministryAndOversight); 
    function dropMinistryBreadcrumb(e){
        dropBreadcrumb(new Breadcrumb("Ministry",mandOServiceElement(oym,ministryObject,dropBreadcrumb,authenticated,true)));
    }
    function dropElderBreadcrumb(e){
        dropBreadcrumb(new Breadcrumb("Elder",mandOServiceElement(oym,elderObject,dropBreadcrumb,authenticated,true)));
    }
    function dropOverseerBreadcrumb(e){
        dropBreadcrumb(new Breadcrumb("Overseer",mandOServiceElement(oym,overseerObject,dropBreadcrumb,authenticated,true)));
    }
    let description = (oym.data.ministryAndOversight.description!==null) ? oym.data.ministryAndOversight.description : "No discription available";
    let ministryButton=(<><button onClick={dropMinistryBreadcrumb}>Ministry</button>&nbsp;&nbsp;&nbsp;</>);
    let elderButton=(<><button onClick={dropElderBreadcrumb}>Eldership</button>&nbsp;&nbsp;&nbsp;</>);
    let overseerButton=(<><button onClick={dropOverseerBreadcrumb}>Oversight</button>&nbsp;&nbsp;&nbsp;</>);
    let members = 
        (
            <>
            {ministryButton}{elderButton}{overseerButton}
            <h2>Members of Ministry and Oversight</h2>
            <table>
            <TermList oym={oym} list={oym.ministryAndOversightMembership} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated} noTerm={true}/>
            </table>
            </>
        );

    return (
        <div style={{whiteSpace: "pre-wrap"}} > 
            <h1>Ministry & Oversight</h1>
            {description}
            {members}
        </div>
    )
}
